import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LeagueDetailsService {

  constructor(private httpClient: HttpClient) { }

  follow(leagueId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/league/follow`, { leagueId });
  }

  unfollow(leagueId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/league/unfollow`, { leagueId });
  }
}
